import { AbstractControl, ValidationErrors } from '@angular/forms';

export const decimalValidator =
  (decimalPlaces: number) =>
  (control: AbstractControl): ValidationErrors | null => {
    if (control.value != null && control.value !== '') {
      const value = control.value.toString().replace(',', '.');
      const regex = new RegExp(`^\\d+(\\.\\d{0,${decimalPlaces}})?$`);
      if (!regex.test(value)) {
        return { decimal: `Value must have up to ${decimalPlaces} decimal places` };
      }
    }
    return null;
  };
